import { render, staticRenderFns } from "./OccurrenceTypeSucessPersistView.vue?vue&type=template&id=51735c0a"
import script from "./OccurrenceTypeSucessPersistView.vue?vue&type=script&lang=ts"
export * from "./OccurrenceTypeSucessPersistView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports